import React from 'react';
import { StyledExternalTeaser, Title, Link, TitleText } from './ExternalTeaser.styles';
import PlayImage from '../../../../ui-components/PlayImage/PlayImage';
import { ExternalIcon } from '../../../Link';
import PlayText from '../../../../ui-components/typography/PlayText/PlayText';
// import { Heading5 } from '../../../../ui-components/typography/Heading.styles';

const ExternalTeaser = ({ url, title, linkTitle, description, image, index, isExternal }) => {
    return (
        <StyledExternalTeaser data-rt="external-teaser">
            <Link className={`lp_pos${index}`} title={linkTitle} href={url}>
                <PlayImage src={image} imageRatio="cinema" />
                <Title as="h2">
                    <ExternalIcon isExternal={isExternal}>
                        <TitleText>{title}</TitleText>
                    </ExternalIcon>
                </Title>
                <PlayText>{description}</PlayText>
            </Link>
        </StyledExternalTeaser>
    );
};

export default ExternalTeaser;
